import halfLogo from "../../../../static/images/logo/half.svg";
import illustrationImg from "../../../../static/images/staff_register_illustration.png";
import vectorBgImg from "../../../../static/images/staff_register_vector_bg.png";


// TODO(HatsuneMiku): Rename file and move to account folder
export default function StaffRegisterLayout({ widget }) {
  function buildDecorativeSection() {
    return (
      <div className="relative hidden flex-[1.2] flex-col items-center justify-end pb-10 lg:flex">
        {/* The Swirly Background Vector */}
        <img
          src={vectorBgImg}
          alt=""
          className="absolute top-0 left-0 w-full h-auto z-0 opacity-80"
        />
        {/* Ellipse 1 - The Shadow under the feet */}
        <div className="absolute bottom-[60px] left-1/2 z-[1] h-[71px] w-[80%] max-w-[736px] -translate-x-1/2 rounded-[50%] bg-creation-neutral-solid-on-surface-disabled" />
        {/* The Characters */}
        <img
          src={illustrationImg}
          alt="Staff Illustration"
          className="w-[90%] max-w-[700px] relative z-[2]"
        />
      </div>
    );
  }

  return (
    <div className="relative flex w-full h-screen bg-main-background-system-default-dim m-0 p-0 font-sans overflow-hidden">
      <img
        src={vectorBgImg}
        alt=""
        className="pointer-events-none absolute top-0 left-0 z-0 w-full h-auto opacity-80 lg:hidden"
      />

      {/* ── Left Side: Decorative ── */}
      {buildDecorativeSection()}

      {/* ── Right Side: Logo & Form ── */}
      <div className="relative z-[1] flex-1 flex flex-col items-center justify-center px-5">
        {/* Logo */}
        <img
          src={halfLogo}
          alt="ใกล้หมอ"
          className="w-[191px] h-[56px] mb-12 md:w-[320px] md:h-auto lg:mb-[65px]"
        />
        {/* Widget Container E.G. (Login Box) */}
        <div className="w-full max-w-[450px] flex justify-center">
          {/* If widget is null, show the black placeholder box */}
          {widget ? widget : (
            <div className="w-full h-[350px] bg-black rounded-2xl shadow-[0px_10px_25px_rgba(0,0,0,0.1)]" />
          )}
        </div>
      </div>
    </div>
  );
}
